import ordersService from '../../services/orders'


const state = {
  currentOrders: [],
  readyOrders : [],
  itemsTable : [],
  visibleRows : []
}

// getters
const getters = {
    totalOrders: state => {
        if (state.currentOrders != null) {
            return state.currentOrders.length;
        }
        else {
            return 0;
        }
    },
    totalPendingOrders : state => {
        if (state.readyOrders != null && state.currentOrders != null) {
            return state.currentOrders.length - state.readyOrders.length;
        }
        else {
            return 0;
        }
    },
    totalRevenue: state => {
        if (state.currentOrders != null) {
            let total = 0;
            state.currentOrders.forEach(order => {
                order.orderDetails.forEach(detail => {
                    total = total + detail.itemPrice * detail.quantity;
                })
            });
            return total;
        }
        else {
            return 0;
        }
    },
    bestSeller : state => {
        if (state.itemsTable != null) {
            return state.itemsTable[0];
        }
        else {
            return 'None';
        }
    }
 
}

// actions
const actions = {
    async getCurrentOrdersAction(context) {
        await ordersService.getCurrentOrders()
                            .then(data => {
                                context.commit('setCurrentOrdersState', data)
                            }) 
    },
    async updateOrderStatusAction(context, order) {

    }
}

// mutations
const mutations = {
    setCurrentOrdersState(state, orders) {
        state.currentOrders = orders;
        //
        //init itemsTable
        //
        state.currentOrders.forEach(order => {
            order.orderDetails.forEach(detail => {
                let index = state.itemsTable.findIndex(i => {
                    i.itemId === detail.itemId
                });
                if (index > -1) {
                    state.itemsTable[index].quantity += detail.quantity;
                }
                else {
                    let item = {
                        itemId : detail.itemId,
                        quantity : detail.quantity,
                        itemName : detail.itemName
                    };
                    
                    state.itemsTable.push(item);
                }
            })
        });
        //
        //sort the itemsTable
        //
        state.itemsTable.sort((a, b) => (a.quantity > b.quantity) ? 1 : -1);
        //
        //init visibleRows
        //
        for (var i = 0; i < state.currentOrders.length; i++) {
            state.visibleRows[i] = false;
        }

    },
    addOrderState(state, order) {
        state.currentOrders.unshift(order); 
    },
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    
}